var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.promotion)?_c(_vm.promotion,{tag:"component"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }